<script>
export default {
  computed: {
    pageIndex () {
      const index = this.$route.query.p - 0
      return Number.isInteger(index) ? index : 1
    },
    pageIndexMax () {
      return Math.ceil(this.specialList.length / 10)
    },
    prev () {
      return this.pageIndex - 1 || false
    },
    next () {
      return this.pageIndex < this.pageIndexMax ? this.pageIndex + 1 : false
    },
    specialList () {
      return Object.keys(this.docs.special).map(key => ({
        specialId: key,
        ...this.docs.special[key]
      }))
    },
    list () {
      return this.specialList.filter((special, index) => {
        return (this.pageIndex - 1) * 10 <= index && index < this.pageIndex * 10
      })
    }
  }
}
</script>

<template>
  <div class="gp-special-list transition-item">
    <div class="special-list-container">
      <transition name="slide-in">
        <ul class="special-list" :key="pageIndex">
          <li
            v-for="special in list"
            :key="special.specialId"
          >
            <router-link :to="{name: 'special-article', params: {'specialId': special.specialId}}">
              <figure><img :src="special.image"></figure>
              <div class="title is-size-6-mobile has-text-weight-bold has-text-align-center">
                {{ special.title }}
              </div>
            </router-link>
          </li>
        </ul>
      </transition>
    </div>
    <nav>
      <div class="level-center is-mobile is-family-oswald has-text-weight-bold is-size-2">
        <div :class="{disable: !prev}">
          <router-link :to="{query: {p: prev}}">
            <span :class="{link: prev}">PREV</span>
          </router-link>
        </div>
        <ul class="level is-mobile">
          <li
            v-for="p in pageIndexMax"
            :key="p"
            :class="{current: p === pageIndex}"
          >
            <router-link :to="{query: {p: p}}">
              <span class="link">{{ p }}</span>
            </router-link>
          </li>
        </ul>
        <div :class="{disable: !next}">
          <router-link :to="{query: {p: next}}">
            <span :class="{link: next}">NEXT</span>
          </router-link>
        </div>
      </div>
    </nav>
    <div>
      <transition name="slide-up">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-special-list {
  .special-list-container {
    position: relative;
    @include is-not-mobile {
      width: calc(100% - 5rem);
      max-width: 55rem;
    }
  }
  ul.special-list {
    justify-content: space-between;
    @include is-mobile {
      padding: 0 1.5rem;
    }
    @include is-not-mobile {
      display: flex;
      flex-wrap: wrap;
    }
    li {
      @include is-mobile {
        margin-bottom: 1.75rem;
      }
      @include is-not-mobile {
        margin-bottom: 3rem;
        width: calc(100% / 2 - 2.5rem);
        max-width: 25rem;
        &:not(:nth-child(2n)) {
          margin-right: 5rem;
        }
      }
      .title {
        margin-top: .5rem;
        @include is-not-mobile {
          margin-top: 1rem;
        }
      }
      figure {
        background-color: $black;
      }
    }
  }
  nav {
    div {
      margin: 0 1rem;
    }
    ul li {
      margin: 0 .5rem;
      span {
        padding: 0 .625rem;
      }
    }
    .current .link,
    .link:hover {
      color: $yellow;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/special/special-list.vue